import React, { FC, useState } from 'react';
import { useStaticPermission } from 'common/auth/Authorize';
import { DataTableToolbar } from '@utmost.co/utmost-design-system';
import { IconButton } from '@beeline.com/bp-design-system';
import { useCustomFieldsAndObjectsIntl } from '../translations/useCustomFieldsAndObjectsIntl';
import { CreateCustomObjectDialog } from './CreateCustomObjectDialog';

interface Props {
  value: string;
  onValueChange: (value: string) => void;
  totalCount: number;
  pageDataCount: number;
  onSubmitDone: () => void;
}

export const ObjectsToolbar: FC<React.PropsWithChildren<Props>> = ({
  onSubmitDone,
  value,
  onValueChange,
  totalCount,
  pageDataCount
}) => {
  const intl = useCustomFieldsAndObjectsIntl();
  const { CREATE } = useStaticPermission('CUSTOM_FIELD_DEFINITION');

  const [openCreateModal, setOpenCreateModal] = useState(false);
  return (
    <>
      <DataTableToolbar
        message={intl.objectTotalCount({ totalCount, pageDataCount })}
        searchProps={{
          value,
          onValueChange
        }}
        beforeActions={
          <IconButton
            disabled={!CREATE}
            disabledToolTipText={intl.noPermissionForAction}
            tooltipText={intl.createCustomObject}
            iconName="add"
            dataTest="add-parent-object"
            onClick={() => setOpenCreateModal(true)}
          />
        }
      />
      <CreateCustomObjectDialog
        key={openCreateModal ? 'open' : 'close'}
        onCreate={onSubmitDone}
        open={openCreateModal}
        onCloseModal={() => setOpenCreateModal(false)}
      />
    </>
  );
};
